import authInstance from 'config/axios.config';

export const propertyServices = {
  getProperties: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/property/admin?${params}`);
    return res.data;
  },

  getPropertyById: async (propertyId) => {
    const res = await authInstance.get(`/property/admin/${propertyId}`);
    return res.data;
  },

  updateProperty: async ({ propertyId, data }) => {
    const res = await authInstance.patch(`/property/admin/${propertyId}`, data);
    return res.data;
  },

updateProperty: async ({ propertyId, data }) => {
  
    const res = await authInstance.patch(
      `/property/admin/${propertyId}`,
      data
    );

    // console.log("response from updateProperty", res.data)
    return res.data;
  },



  deleteProperty: async (propertyId) => {
    const res = await authInstance.delete(`/property/admin/${propertyId}`);
    return res.data;
  },

  toggleActiveStatus: async ({ propertyId, status }) => {
    const res = await authInstance.patch(`/property/admin/${propertyId}`, { status });
    return res.data;
  },

  updateApprovalStatus: async ({ propertyId, approvalStatus, rejectionReason }) => {
    const res = await authInstance.patch(`/property/admin/${propertyId}`, {
      approvalStatus,
      rejectionReason,
    });
    return res.data;
  },

  uploadFile:  async (file) => {
  
    const formData =
      new FormData();
  
    formData.append(
      'file',
      file
    );
  
    const res =
      await authInstance.post(
  
        '/admin/upload',
  
        formData,
  
        {
          headers:{
            'Content-Type':
            'multipart/form-data'
          }
        }
  
      );
  
    return res.data;
  },

  exportProperties: async ({
  propertyCategory,
  propertyType,
  approvalStatus,
  furnishing,
  constructionStatus,
  search,
  sortBy,
  sortOrder,
}) => {
  const params =
    new URLSearchParams({
      propertyCategory:
        propertyCategory === 'all'
          ? ''
          : propertyCategory || '',

      propertyType:
        propertyType === 'all'
          ? ''
          : propertyType || '',

      approvalStatus:
        approvalStatus === 'all'
          ? ''
          : approvalStatus || '',

      furnishing:
        furnishing === 'all'
          ? ''
          : furnishing || '',

      constructionStatus:
        constructionStatus === 'all'
          ? ''
          : constructionStatus || '',

      search:
        search || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/property/admin/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},


};
